import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { getDeleteErrorMessage } from 'src/pages/Items';
import type { IResponseError } from 'src/types';

/**
 * Deletes a menu item by ID.
 *
 * Note: if this function is called from a menu context, a reference item will be removed.
 *
 * @param itemId - The ID of the item to delete.
 * @returns An empty object when the API responds with `204 No Content`.
 * @throws {Error} When the request fails (non-OK response) or when a `400 Bad Request` error is returned.
 */
export const deleteMenuItem = async (itemId: string): Promise<any> => {
  const res = await fetch(`${API_URL}/items/${itemId}`, {
    method: 'DELETE',
  });

  if (!res.ok && res.status !== Status.BAD_REQUEST) {
    throw new Error('Something went wrong whilst deleting the product');
  }

  if (res.status === Status.BAD_REQUEST) {
    const error: IResponseError = await res.json();
    const errorMessage = getDeleteErrorMessage(error);

    throw new Error(errorMessage);
  }

  if (res.status === Status.NO_CONTENT) return {};
};
